import AxiosClient from "../../../services/axios.services";

class BudgetControlActionsServices {
  getFormResponses = (filters = {}) =>
    AxiosClient.get("/api/app/capacitacion_dnc_formulario_respuestas/", {
      headers: { "Content-Type": "application/json" },
      params: filters,
    });

  createFormResponse = (data) =>
    AxiosClient.post("/api/app/capacitacion_dnc_formulario/", data, {
      headers: { "Content-Type": "application/json" },
    });

  changeStatusQuestions = (data, id) =>
    AxiosClient.post(`/api/app/capacitacion_dnc_preguntas_estado/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  createQuestionForm = (data) =>
    AxiosClient.post("/api/app/capacitacion_dnc_preguntas/", data, {
      headers: { "Content-Type": "application/json" },
    });

  editQuestionForm = (data, id) =>
    AxiosClient.put(`/api/app/capacitacion_dnc_preguntas_editar/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  getFormEmployee = (filters = {}) =>
    AxiosClient.get("/api/app/capacitacion_dnc_lista_preguntas_activas/", {
      headers: { "Content-Type": "application/json" },
      params: filters,
    });

  getForm = () =>
    AxiosClient.get("/api/app/capacitacion_dnc_lista_preguntas/", {
      headers: { "Content-Type": "application/json" },
    });
}

export default new BudgetControlActionsServices();
